import * as React from 'react';
import * as XmlJS from 'xml-js';
import MonoComponent from '../shared/MonoComponent';
import SetComponent from '../shared/SetComponent';
import MathBoxComponent from '../shared/MathBoxComponent';
import MathComponent from '../shared/MathComponent';
import {Link} from 'react-router-dom';

export default class BBMLParser {

	public static execute (value: string) {
		return this.parse(XmlJS.xml2js('<root>' + value + '</root>').elements[0]);
	}

	public static executeWithoutException (value: string) {
		try {
			return this.parse(XmlJS.xml2js('<root>' + value + '</root>').elements[0]);

		} catch (error) {
			console.log(error);
			return '';
		}
	}

	private static parse  (value: any, key?: number): any {
		if (Array.isArray(value)) {
			return value.length === 1 ? this.parse(value[0]) : value.map((elementValue, elementKey) => this.parse(elementValue, elementKey));
		}

		if (typeof value === 'object' && value.type === 'text') {
			return <span key={key}>{value.text}</span>;
		}

		if (typeof value === 'object' && value.type === 'element') {

			if (value.name === 'root') {
				return <span key={key}>{this.parse(value.elements)}</span>;
			}

			if (value.name === 'p') {
				return <p key={key}>{this.parse(value.elements)}</p>;
			}

			if (value.name === 'sub') {
				return <sub key={key}>{this.parse(value.elements)}</sub>;
			}

			if (value.name === 'sup') {
				return <sup key={key}>{this.parse(value.elements)}</sup>;
			}

			if (value.name === 'a') {
				return value.attributes.href[0] !== '/' ? <a key={key} href={value.attributes.href} target='_blank'>{this.parse(value.elements)}</a> : <Link to={value.attributes.href}>{this.parse(value.elements)}</Link>;
			}

			if (value.name === 'Mono') {
				return <MonoComponent key={key}>{this.parse(value.elements)}</MonoComponent>;
			}

			if (value.name === 'Set') {
				return <SetComponent key={key}>{this.parse(value.elements)}</SetComponent>;
			}

			if (value.name === 'strong') {
				return <strong key={key}>{this.parse(value.elements)}</strong>;
			}

			if (value.name === 'em') {
				return <em key={key}>{this.parse(value.elements)}</em>;
			}

			if (value.name === 'img') {
				let cutTop = 0, cutRight = 0, cutBottom = 0, cutLeft = 0;

				if (value.attributes.crop) {
					const cuts = (value.attributes.crop as string).split(' ').map(crop => Number(crop));
					if (cuts.length === 1) {
						cutTop = cutRight = cutBottom = cutLeft = cuts[0];
					} else if (cuts.length === 2) {
						cutTop = cutBottom = cuts[0];
						cutRight = cutLeft = cuts[1];
					} else if (cuts.length === 2) {
						cutTop = cuts[0];
						cutRight = cutLeft = cuts[1];
						cutBottom = cuts[2];
					} else if (cuts.length === 4) {
						cutTop = cuts[0];
						cutRight = cuts[1];
						cutBottom = cuts[2];
						cutLeft = cuts[3];
					}
				}

				let queryArray = [];
				if (cutTop !== 0) {
					queryArray.push('top=' + cutTop);
				}
				if (cutRight !== 0) {
					queryArray.push('right=' + cutRight);
				}
				if (cutBottom !== 0) {
					queryArray.push('bottom=' + cutBottom);
				}
				if (cutLeft !== 0) {
					queryArray.push('left=' + cutLeft);
				}

				let source = value.attributes.src;

				if (queryArray.length !== 0) {
					source = 'https://brainbrooder.com/api/image?url=' + encodeURIComponent(source) + '&' + queryArray.join('&');
				}

				return <img key={key} alt={value.attributes.alt} title={value.attributes.title} src={source} style={{display: 'block', maxWidth: '100%', margin: '1em auto', backgroundColor: value.attributes.background || 'inherit', filter: 'invert(' + (value.attributes.inverted === 'true' ? .888 : 0) + ')'}} />;
			}

			if (value.name === 'caption') {
				return <span key={key} style={{display: 'block', fontSize: '0.7em', textAlign: 'center', marginTop: '-1em', color: '#cccccc'}}>{this.parse(value.elements)}</span>;
			}

			if (value.name === 'br') {
				return <br key={key}/>;
			}

			if (value.name === 'MathBox') {
				return <MathBoxComponent key={key} value={value.elements[0].text} />;
			}

			if (value.name === 'subtext') {
				return <p style={{fontSize: '0.7em', textAlign: 'center', color: '#cccccc'}}>{this.parse(value.elements)}</p>;
			}

			if (value.name === 'Math') {
				let text = '';

				if (value.elements !== undefined) {
					value.elements.forEach((element: any) => {
						if (element.text) {
							text += element.text;
						} else {
							text += this.parse(element);
						}
					});
				}

				return <MathComponent key={key} value={text} />;
			}

			if (value.name === 'Math') {
				return <MathComponent key={key} value={value.elements[0].text} />;
			}

			return this.errorDiv(key, <span>Unknown element <strong>{value.name}</strong> encountered while parsing ExerciseComponent.</span>);
		}

		if (value === undefined) {
			return '';
		}

		return this.errorDiv(key, <span>Unknown value <strong>{value}</strong> encountered while parsing ExerciseComponent.</span>);
	}

	private static errorDiv (key: number | undefined, message: string | JSX.Element) {
		return <div key={key} style={{color: 'red'}}>{message}</div>;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/BBMLParser.tsx